import { render, staticRenderFns } from "./Participantes.vue?vue&type=template&id=31056560"
import script from "./Participantes.vue?vue&type=script&lang=js"
export * from "./Participantes.vue?vue&type=script&lang=js"
import style0 from "./Participantes.vue?vue&type=style&index=0&id=31056560&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports